import { render, staticRenderFns } from "./ReturnToMemberInfoModal.vue?vue&type=template&id=235952e4&"
import script from "./ReturnToMemberInfoModal.vue?vue&type=script&lang=js&"
export * from "./ReturnToMemberInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports